// extracted by mini-css-extract-plugin
export default {"wrapper":"SidebarLogo_wrapper__NWZNh","ziphyWrapper":"SidebarLogo_ziphyWrapper__wLoZG"};